import useExperiment from 'utils/useExperiment'
import { annualPlan } from 'checkout/subscription/subscriptionPlans'
import { EXPERIMENTS } from './constants'

const freemiumAnnualCheckoutPath = `/checkout/${annualPlan.id}/?upgrade=true`

const freemiumVariants = {
  control: {
    hasFreemium: false,
  },
  'treatment-a': {
    hasFreemium: true,
  },
  'treatment-b': {
    hasFreemium: true,
  },
}

const useFreemiumExperiment = () => {
  const { isExperimentReady, variantValue } = useExperiment(
    EXPERIMENTS.freemium,
  )

  const variant = freemiumVariants[variantValue] ?? freemiumVariants.control

  const getCTAPath = ({ defaultPath } = {}) =>
    variantValue === 'treatment-a' ? freemiumAnnualCheckoutPath : defaultPath

  return { isExperimentReady, getCTAPath, ...variant }
}

export default useFreemiumExperiment
